import {WixSdk} from '@wix/js-sdk-wrapper';
import {getBiToken, getInstanceId, getVisitorId} from '@wix/music-shared/dist/src/utils/wix-utils';
import {safe} from '../utils/functions';

export interface WixParams {
  compId?: string;
  userId?: string;
  visitorId?: string;
  instanceId?: string;
  biToken?: string;
  siteOwnerId?: string;
  isOwner?: boolean;
  deviceType?: string;
  viewMode?: string;
  metaSiteId?: string;
}

export function getWixParams(): WixParams {
  return {
    compId: safe(() => WixSdk.Utils.getCompId()),
    userId: safe(() => WixSdk.Utils.getUid()),
    visitorId: safe(() => getVisitorId()),
    instanceId: safe(() => getInstanceId()),
    biToken: safe(() => getBiToken()),
    siteOwnerId: safe(() => WixSdk.Utils.getSiteOwnerId()),
    isOwner: safe(() => WixSdk.Utils.getUid() === WixSdk.Utils.getSiteOwnerId()),
    deviceType: safe(() => WixSdk.Utils.getDeviceType()),
    viewMode: safe(() => WixSdk.Utils.getViewMode()),
    metaSiteId: safe(() => WixSdk.Utils.getInstanceValue('metaSiteId')),
  };
}
